import { Snackbar, Alert } from "@mui/material";

function RibbonWidget({ open, message, onClose }) {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <Alert severity="error" onClose={onClose}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default RibbonWidget;
